import { Select } from '@consta/uikit/Select'
import { Text } from '@consta/uikit/Text'
import { TreeInput } from '@core/components'
import { HORIZON, POLYGON, SEISMIC_SURVEY } from '@core/core/constants'
import { textProps } from '@core/core/helpers'
import type { BaseEntity, BaseObjectProperties, ObjectTypes } from '@core/core/types'
import type { BaseObject, Nullable } from 'common/types'
import type { FC } from 'react'

import { paramItems } from '../../../constants'
import css from './SelectGroup.css'

function getName(type: ObjectTypes) {
  switch (type) {
    case SEISMIC_SURVEY:
      return 'Сейсмическая съемка'
    case HORIZON:
      return 'Горизонт'
    case POLYGON:
      return 'Полигон'
  }
}

function getAllowedTypes(type: ObjectTypes): BaseObject[] {
  switch (type) {
    case SEISMIC_SURVEY:
      return ['survey2d', 'cube']
    case HORIZON:
      return ['interpretation3D']
    case POLYGON:
      return ['polygon']
  }
}

type SelectGroupProps = {
  type: ObjectTypes
  value: BaseObjectProperties
  onChange: (value: BaseObjectProperties) => void
  cubeName?: string
  withParams?: boolean
  tooltip?: string
}

export const SelectGroup: FC<SelectGroupProps> = ({
  type,
  value,
  onChange,
  withParams,
  tooltip,
  cubeName,
}) => {
  const name = getName(type)
  const allowedTypes = getAllowedTypes(type)
  const isAlertStatus =
    cubeName !== undefined &&
    value.entity?.entityName !== undefined &&
    value.entity.entityName !== cubeName &&
    type === 'horizon'

  const handleChange = (
    field: keyof BaseObjectProperties,
    newValue?: string | Nullable<BaseEntity>,
  ) => {
    onChange({ ...value, [field]: newValue })
  }

  return (
    <div className={css.container}>
      <Text {...textProps}>{name}</Text>
      <TreeInput
        value={value.entity}
        allowedTypes={allowedTypes}
        tooltip={tooltip}
        status={isAlertStatus ? 'alert' : undefined}
        caption={isAlertStatus ? 'Горизонт лежит за пределами выбранной съемки' : undefined}
        onChange={value => {
          handleChange('entity', value)
        }}
      />
      {!!withParams && (
        <Select
          size="xs"
          items={paramItems}
          value={paramItems.find(item => item.id === value.parameter)}
          disabled={true}
          onChange={value => {
            handleChange('parameter', value?.id)
          }}
        />
      )}
    </div>
  )
}
